import React, { Component } from 'react';
import Tile from '../components/tile';
import Video from '../components/video';
class HeidelBerg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
      videoUrl: '',
      images: [
        {
          url:  'heidelberg.jpg',
          video: 'heidelburg',
          subtitles: undefined,
          subtitlesIrish: undefined,
          prevText: "",
          nextText: "Next Printer"
        },
         {
          url:  'heidelberg.jpg',
          video: 'billyRyan',
          prevText: "Previous Printer",
          subtitlesIrish: 'captions_Irish_Heidelberg.vtt',
          subtitles: 'captions_Heidelberg.vtt',
          nextText: ""
        },
       
      ],
      mediaIndex: 0
    };
  }
  
  playVideo(index) {
    this.setState({ playVideo: true, mediaIndex: index });

    var elem = document.body;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeVideo() {
    this.setState({ playVideo: false, mediaIndex: 0 });

  }

  nextVideo() {
   if( this.state.mediaIndex < this.state.images.length -1 ){
    this.setState({mediaIndex: this.state.mediaIndex + 1})
   }

    else{
      this.setState({ playVideo: false, mediaIndex: 0 });
    }
  }

  prevVideo() {
    if( this.state.mediaIndex > 0 )
    this.setState({mediaIndex: this.state.mediaIndex - 1})
  }
  render() {
    const mediaIndex = this.state.mediaIndex;
    const text =
    'The Heidelberg Platen is an automatic, power driven printing press. It was mainly used for jobbing work such as letter headings and business cards.';
    return (
      <div className="shaw">
        {this.state.playVideo ? (
          <Video
            onClose={() => this.closeVideo()}
            onNext={() => this.nextVideo() }
            playNext={() => this.nextVideo()}
            nextText={this.state.images[mediaIndex].nextText}
            noLast={this.state.mediaIndex === this.state.images.length -1}
            noFirst={this.state.mediaIndex === 0}
            onPrev={() => this.prevVideo()}
            subtitles={this.state.images[mediaIndex].subtitles} 
            subtitlesIrish={this.state.images[mediaIndex].subtitlesIrish}
            videoUrl={this.state.images[mediaIndex].video}
            imageUrl={this.state.images[mediaIndex].url}
            nextText={this.state.images[mediaIndex].nextText}
            prevText={this.state.images[mediaIndex].prevText}
          />
        ) : (
          <div style={{flex: 1}}>
            <Tile
              bg={'heidelberg.jpg'}
              titleImage={'Heidelberg.png'}
              onPlay={(index) => this.playVideo(index)}
              title={'Vandercook Proofing Press, Printer - Freddie Snowe'}
              subTitle={
                '- Billy Ryan'
              }
              bold={'Printer'}
              text={text}
            />
            </div>
        )}
      </div>
    );
  }
}

export default HeidelBerg;



// WEBPACK FOOTER //
// ./src/pages/Heidelberg.js